<script>
import {ref, provide} from 'vue';

export default {
  name: 'AkShimmerGroup',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    let shimmerLoading = ref(props.loading);
    provide('shimmerLoading', shimmerLoading);

    return {shimmerLoading};
  },
  watch: {
    loading(newVal) {
      this.shimmerLoading = newVal;
    },
  },
};
</script>

<template>
  <slot name="default"></slot>
</template>

<style scoped></style>
